import React, {useEffect, useState} from 'react'

import CheckoutErrorContext from '../components/CheckoutErrorContext'

export default function CheckoutErrorProvider({children}: {children: React.ReactNode}) {
  const [error, setError] = useState<{section?: string; error?: string}>({})
  const [animateError, setAnimateError] = useState(true)

  useEffect(() => {
    if (error.error) {
      setAnimateError(true)
      setTimeout(() => setAnimateError(false), 6000)
    }
  }, [error])

  return (
    <CheckoutErrorContext.Provider
      value={{
        error,
        showAnimation: animateError,
        setError: (section: string, error: string) => {
          setError({section, error})
        },
        clearError: () => {
          setError({})
        }
      }}>
      {children}
    </CheckoutErrorContext.Provider>
  )
}
